<template>
  <div class="data-list-panel-v">
    <template v-if="items && items.length">
      <a v-for="(item, index) in items"
         :key="`item-${index}`"
         :href="item.url || 'javascript:;'"
         :target="item.url ? '_blank' : ''"
         class="list-item"
         :class="{ clickable: item.url }">
        <div v-if="item.icon"
             class="prepend">
          <i :class="item.icon"></i>
        </div>
        <div class="body">
          <div class="title">{{item.title}}</div>
          <div class="label">{{item.label}}</div>
        </div>
        <div class="append">
          <div>{{item.value}}</div>
        </div>
      </a>
    </template>
    <template v-else>
      <Hint type="empty">
        <div>列表数量为空</div>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../Hint'
export default {
  name: 'ListPanel',
  components: {Hint},
  props: {
    items: Array
  }
}
</script>

<style lang="scss" scoped>
.data-list-panel-v {
  height: 100%;

  .list-item {
    display: flex;
    align-items: center;
    padding: 10px 14px;
    border-bottom: 1px solid #ebeef5;
    background: #fff;
    transition: background-color 0.2s;
    text-decoration: none;
    color: inherit;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: #f5f7fa;
    }

    &.clickable {
      cursor: pointer;

      &:hover {
        background-color: #ecf5ff;
      }
    }

    &>.prepend {
      flex: none;
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      background: #f0f2f5;
      border-radius: 5px;
      color: #606266;
      font-size: 14px;
    }

    &>.body {
      flex: 1;
      min-width: 0;

      .title {
        font-size: 13px;
        color: #303133;
        line-height: 1.4;
      }

      .label {
        font-size: 12px;
        color: #909399;
        margin-top: 2px;
        line-height: 1.4;
      }
    }

    &>.append {
      flex: none;
      margin-left: 10px;
      font-size: 13px;
      color: #606266;
      text-align: right;
    }
  }
}
</style>
